var WalletExposedMethods;
(function(WalletExposedMethods2) {
  WalletExposedMethods2["GO_TO_HOME_VIEW"] = "goToHomeView";
  WalletExposedMethods2["GO_TO_PREVIOUS_VIEW"] = "goToPreviousView";
  WalletExposedMethods2["SET_DEPOSIT_METHOD"] = "setDepositMethod";
  WalletExposedMethods2["SET_WITHDRAWAL_METHOD"] = "setWithdrawalMethod";
  WalletExposedMethods2["SET_LANGUAGE_CODE"] = "setLanguageCode";
  WalletExposedMethods2["SET_VIEW"] = "setView";
  WalletExposedMethods2["SET_THEME"] = "setTheme";
  WalletExposedMethods2["UPDATE_TRANSLATIONS"] = "updateTranslations";
  WalletExposedMethods2["RESUME_DEPOSIT"] = "resumeDeposit";
})(WalletExposedMethods || (WalletExposedMethods = {}));
var WalletRegisterableMethods;
(function(WalletRegisterableMethods2) {
  WalletRegisterableMethods2["GET_GAMES"] = "getGames";
  WalletRegisterableMethods2["GET_BONUSES"] = "getBonuses";
  WalletRegisterableMethods2["ON_GAME_SELECTED"] = "onGameSelected";
  WalletRegisterableMethods2["GET_PRESELECTED_PARAMS_ON_DEPOSIT_FAIL"] = "getPreSelectedParamsOnDepositFail";
  WalletRegisterableMethods2["GET_PRESELECTED_PARAMS_ON_WITHDRAWAL_FAIL"] = "getPreSelectedParamsOnWithdrawalFail";
  WalletRegisterableMethods2["GO_TO_GAMES"] = "goToGames";
  WalletRegisterableMethods2["ON_EVENT"] = "onEvent";
  WalletRegisterableMethods2["GET_REMAINING_DEPOSIT_LIMITS"] = "getDepositRemainingLimits";
})(WalletRegisterableMethods || (WalletRegisterableMethods = {}));

export { WalletExposedMethods, WalletRegisterableMethods };
